import React, { useState } from "react";
import { Box, Card, Grid, Paper, Stack, Typography } from "@mui/material";
import { IMAGE_URL } from "network";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import SmallMap from "utility/SmallMap";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import PinDropIcon from "@mui/icons-material/PinDrop";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Location from "utility/location";
import Swal from "sweetalert2";
import { useUnlinkAreaMutation } from "slices/beautyApp/beauticianSlice";
import ServicesModal from "utility/servicesModal";
export default function ServicesTab({ beautician, refetch }) {
  const services = beautician?.beauticianServices || [];

  const [openLocations, setLocations] = useState(false);
  const [openServices, setServices] = useState(false);
  const [del] = useUnlinkAreaMutation();

  const delLocation = async (linkk) => {
    if (window.confirm("Are you sure you want delete this area?")) {
      try {
        const response = await del(linkk._id).unwrap();
        if (response) {
          refetch();
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error?.data?.message || error?.message || "Server error",
        });
      }
    }
  };

  const setProfileClose = () => {
    setLocations(false);
    setServices(false);
    refetch();
  };

  return (
    <Box>
      <Location
        open={openLocations}
        data={beautician}
        usertype={"beautician"}
        onClose={() => setProfileClose()}
      />

      <ServicesModal
        open={openServices}
        data={beautician}
        usertype={"beautician"}
        onClose={() => setProfileClose()}
      />

      <Card
        sx={{
          p: 4,
          borderRadius: 6,
          mb: 4,
          boxShadow: 8,
          background: "linear-gradient(to right, #fdf7e8ff, #e3f1c3ff)",
          color: "#333",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} mb={2}>
          <MiscellaneousServicesIcon color="primary" />
          <Typography variant="h6" fontWeight={600}>
            Service Deal In:
          </Typography>
        </Stack>

        <AddIcon
          color="primary"
          sx={{ position: "absolute", top: 16, right: 16 }}
          onClick={() => setServices(true)}
        />

        {services.length > 0 ? (
          services.map((service, idx) => (
            <Paper
              key={idx}
              elevation={4}
              sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                borderRadius: 4,
                transition: "transform 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 10,
                },
                mb: 2,
              }}
            >
              <img
                crossOrigin="anonymous"
                src={IMAGE_URL + service?.category?.image}
                alt={service?.category?.name}
                height="100px"
                width="100px"
                style={{
                  borderRadius: "50%",
                  objectFit: "cover",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  border: "3px solid #fff",
                  marginRight: 16,
                }}
              />
              <Box>
                <Typography variant="subtitle1" fontWeight={500}>
                  {service?.category?.name}
                </Typography>
              </Box>
            </Paper>
          ))
        ) : (
          <Typography color="text.secondary">
            No service category added yet.
          </Typography>
        )}
      </Card>
      <Grid item xs={12} md={12}>
        <Card
          sx={{
            p: 4,
            borderRadius: 6,
            mb: 4,
            boxShadow: 8,
            background: "linear-gradient(to right, #fdf7e8ff, #e3f1c3ff)",
            color: "#333",
          }}
        >
          <AddIcon
            color="primary"
            sx={{ position: "absolute", top: 16, right: 16 }}
            onClick={() => setLocations(true)}
          />
          <Stack direction="row" alignItems="center" spacing={1} mb={2}>
            <PinDropIcon color="primary" />
            <Typography variant="h6" fontWeight={600}>
              Selected City and Areas
            </Typography>
          </Stack>
          {beautician?.areaLinks?.length ? (
            <>
              {[
                ...new Map(
                  beautician?.areaLinks
                    .filter((item) => item?.area?.city)
                    .map((item) => [
                      item?.area?.city?._id,
                      item?.area?.city,
                    ]),
                ).values(),
              ].filter(Boolean).map((city) => (
                <Box key={city?._id} mb={3}>
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    color="primary"
                    mb={1}
                  >
                    {city?.cityName}
                  </Typography>

                  <Slider
                    dots={true}
                    infinite={false}
                    speed={500}
                    slidesToScroll={1}
                    responsive={[
                      {
                        breakpoint: 500,
                        settings: {
                          slidesToShow: 1,
                        },
                      },
                      {
                        breakpoint: 1000,
                        settings: {
                          slidesToShow: 1,
                        },
                      },
                      {
                        breakpoint: 2000,
                        settings: {
                          slidesToShow: 2,
                        },
                      },
                    ]}
                  >
                    {beautician?.areaLinks
                      .filter((link) => link?.area?.city?._id === city?._id && link?.area)
                      .map((link) => {
                        const coords = [
                          link?.area?.location?.coordinates?.[1],
                          link?.area?.location?.coordinates?.[0],
                        ];

                        return (
                          <Box key={link?._id} px={2}>
                            <Card
                              sx={{
                                p: 2,
                                borderRadius: 4,
                                boxShadow: 4,
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                              }}
                            >
                              <DeleteIcon
                                color="primary"
                                sx={{
                                  position: "absolute",
                                  top: 16,
                                  right: 16,
                                }}
                                onClick={() => delLocation(link)}
                              />
                              <Typography
                                variant="subtitle1"
                                fontWeight={600}
                                mb={1}
                              >
                                {(link.area.areaName || "").length > 50
                                  ? link.area.areaName.slice(0, 50) + "..."
                                  : link.area.areaName || "—"}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                mb={1}
                              >
                                Pincode: {link.area.pincode || "—"}
                              </Typography>
                              <SmallMap coordinates={coords} />
                            </Card>
                          </Box>
                        );
                      })}
                  </Slider>
                </Box>
              ))}
            </>
          ) : (
            <Typography color="text.secondary">
              No area data available.
            </Typography>
          )}
        </Card>
      </Grid>
    </Box>
  );
}
